import {PurchaseRequest} from '../../../../../models/PurchaseRequest.js';
import {DISABLE_REASONS} from '../reasons.js';

/**
 * Disables a field on the submitted-requests tab.
 * @param {Object} ctx
 * @return {string|false}
 */
export function submittedTab(ctx) {
    return ctx.submittedTab ? DISABLE_REASONS.SUBMITTED_TAB : false;
}

/**
 * Disables a field while another user holds the PR.
 * @param {Object} ctx
 * @return {string|false}
 */
export function prLocked(ctx) {
    return ctx.prLocked ? DISABLE_REASONS.PR_LOCKED : false;
}

/**
 * Disables a field when the user cannot edit PR properties.
 * @param {Object} ctx
 * @return {string|false}
 */
export function noAccess(ctx) {
    return ctx.userHasAccessToProperties ? false : DISABLE_REASONS.NO_ACCESS;
}

/**
 * Disables a field on the pending SB tab.
 * @param {Object} ctx
 * @return {string|false}
 */
export function pendingSb(ctx) {
    return ctx.pendingSbTab ? DISABLE_REASONS.PENDING_SB : false;
}

/**
 * Submitted tab, locked PR, and missing access.
 * @type {Array<function(Object): (string|false)>}
 */
export const GLOBAL_LOCK_RULES = [submittedTab, prLocked, noAccess];

/**
 * Global lock plus the pending SB tab.
 * @type {Array<function(Object): (string|false)>}
 */
export const GLOBAL_AND_SB_RULES = [submittedTab, prLocked, noAccess, pendingSb];

/**
 * Hides the save and submit bar on submitted requests, while the PR is locked, or on the open tab without access.
 * @param {Object} ctx
 * @return {string|false}
 */
export function editorActionBar(ctx) {
    if (ctx.submittedTab) {
        return DISABLE_REASONS.SUBMITTED_TAB;
    }
    if (ctx.prLocked) {
        return DISABLE_REASONS.PR_LOCKED;
    }
    if (ctx.tab === PurchaseRequest.tab.open && !ctx.userHasAccessToProperties) {
        return DISABLE_REASONS.NO_ACCESS;
    }
    return false;
}
